import React, { useState } from "react";
import { Dropdown, Menu, Button, message } from "antd";
import { DownOutlined } from "@ant-design/icons";
import ModalEditarUsuario from "./ModalEditarUsuario";
import ModalConfirmacion from "../../generales/ModalConfirmacion";
import ModalPermisosUsuario from "./ModalPermisosUsuario";
import userService from "../../../../services/UserService";
import { useUser } from "../../../../context/UserContext";
import useAuth from "../../../../hooks/useAuth";

const MenuBotonUsuarios = ({ item, fetchData }) => {
  const [show, setShow] = useState(false);
  const [showConfirmacion, setConfirmacion] = useState(false);
  const [showPermisos, setShowPermisos] = useState(false);
  const [LoadingButon, setLoadingButon] = useState(false);
  const user = useUser();
  const { session } = useAuth();
  const isAdmin = session?.user?.role === "Administrador";

  const funcionBoton = async () => {
    setLoadingButon(true);
    try {
      // Aquí iría la lógica para eliminar o desactivar el usuario
      await userService.EliminarUsuario(item.id, user.idToken);
      message.success("Usuario eliminado correctamente");
      fetchData();
      setConfirmacion(false);
    } catch (error) {
      console.error("Error al eliminar el usuario:", error);
      message.error("No se logró eliminar el usuario");
    } finally {
      setLoadingButon(false);
    }
  };

  const handleActivarDesactivar = async () => {
    try {
      const nuevoEstado = !item.isActive;
      await userService.EditarUsusairo(
        item.id,
        { isActive: nuevoEstado },
        user.idToken
      );
      message.success(
        `Usuario ${nuevoEstado ? "activado" : "desactivado"} correctamente`
      );
      fetchData();
    } catch (error) {
      console.error("Error al cambiar estado del usuario:", error);
      message.error("No se logró cambiar el estado del usuario");
    }
  };

  // Contenido del menú desplegable
  const menu = (
    <Menu>
      {isAdmin && (
        <Menu.Item key="0" onClick={() => setShow(true)}>
          Editar usuario
        </Menu.Item>
      )}

      <Menu.Item key="1" onClick={handleActivarDesactivar}>
        {item.isActive ? "Desactivar usuario" : "Activar usuario"}
      </Menu.Item>

      {isAdmin && (
        <Menu.Item key="2" danger onClick={() => setConfirmacion(true)}>
          Eliminar usuario
        </Menu.Item>
      )}

      {isAdmin && (
        <Menu.Item key="3" onClick={() => setShowPermisos(true)}>
          Ver permisos
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menu} placement="bottomLeft">
        <Button>
          <DownOutlined />
        </Button>
      </Dropdown>

      <ModalEditarUsuario
        open={show}
        setOpen={setShow}
        item={item}
        fetchData={fetchData}
      />

      <ModalConfirmacion
        open={showConfirmacion}
        setOpen={setConfirmacion}
        funtion={funcionBoton}
        title="¿Está seguro de que desea eliminar este usuario?"
        message={`Se eliminará permanentemente el usuario: ${item.name} ${item.lastName}. Esta acción no se puede deshacer.`}
        LoadingButon={LoadingButon}
      />

      {isAdmin && (
        <ModalPermisosUsuario
          open={showPermisos}
          setOpen={setShowPermisos}
          item={item}
        />
      )}
    </>
  );
};

export default MenuBotonUsuarios;
